import { useAuth0 } from '@auth0/auth0-react';
import { numberFormat } from 'helper';
import { formatDate } from 'helper/dateFormat';
import FinanceService from 'Lib/API/Finance';
import React, { useEffect, useState } from 'react';
import { toastr } from 'react-redux-toastr';
import './index.scss';

const FinanceList = ({ invoices, account }) => {
  const [balance, setBalance] = useState(null);
  const { getAccessTokenSilently } = useAuth0();

  useEffect(() => {
    if (balance === null) {
      fetchAmountApi();
    }
  }, [balance]);

  const fetchAmountApi = async (e) => {
    const token = await getAccessTokenSilently();
    await FinanceService.getAmountByAccountId(token, account?._id)
      .then((res) => {
        const result = res;
        setBalance(result);
      })
      .catch((err) => {
        toastr.error('Error', err?.data?.message);
      });
  };

  const intValue = balance !== null && parseFloat(balance?.balance);
  const formatedBalance = numberFormat({number:intValue, decimal:2, style: 'currency'}); 

  const intValueCred = balance !== null && parseFloat(balance?.creditOnAccount);
  const formatedCreditOnAccount = numberFormat({number:intValueCred, decimal:2, style: 'currency'}); 

  const intValueOver = balance !== null && parseFloat(balance?.overDue);
  const formatedOverdue = numberFormat({number:intValueOver, decimal:2, style: 'currency'});

  return (
    <>
      {balance !== null ? (
        <div
          style={{
            border: '1px solid rgb(0 46 92 / 17%)',
            borderRadius: '9px',
            padding: '12px 18px',
            marginTop: '10px',
          }}
        >
          <div className='d-flex'>
            <span className="dot" style={{ '--my-color': '#81DC91' }}></span>
            <span className="d-flex justify-content-between w-100">
              Credit on Account
              <span className="amountBold mr-3">
                {formatedCreditOnAccount}
              </span>{' '}
            </span>
          </div>
          <div className='d-flex'>
            <span className="dot" style={{ '--my-color': '#2555EF' }}></span>
            <span className="d-flex justify-content-between w-100">
              Balance
              <span className="amountBold mr-3">{formatedBalance}</span>{' '}
            </span>
          </div>
          <div className='d-flex'>
            <span className="dot" style={{ '--my-color': '#F1585E' }}></span>
            <span className="d-flex justify-content-between w-100">
              Over Due ({balance?.numberOfOverDueCharges ?? 0}){' '}
              <span className="amountBold mr-3">{formatedOverdue}</span>
            </span>
          </div>
        </div>
      ) : (
        <p className="p-5">loading...</p>
      )}
      {invoices?.map((invoice, index) => {
        return (
          <div className="member-card " key={index}>
            <div className="card-content">
              <div className="member-container">
                <div className="member-name">
                  {invoice.memberDetails.member_name}
                  <div className="member-t">
                    {formatDate({date:invoice.inv_due_date, formatType: "defaultWithUTC"})}
                  </div>
                </div>
              </div>
              <div
                className="mr-2 invoice-status"
                style={{
                  background:
                    invoice.payment_amount.payment_status === 'UnPaid'
                      ? '#F94423'
                      : '#4CAF50',
                }}
              >
                {invoice.payment_amount.payment_status === 'UnPaid'
                  ? 'Not Paid'
                  : 'Paid'}
              </div>
            </div>
          </div>
        );
      })}
    </>
  );
};

export default FinanceList;
